<template>
  <div class="row mt-0">
    <div class="flex md12">
      <div class="row">
        <div class="flex md1">
          <va-button
            color="info"
            @click="createNew"
            icon="fa fa-plus"
          />
        </div>
        <div class="flex md11">
          <h4
            class="fullwidth"
            style="position: relative; top: 0.5em"
          >
            Ajouter un commentaire
          </h4>
        </div>
      </div>
      <div class="row">
        <div
          class="flex md12"
          v-if="commentList.length < 1"
        >
          <p class="text--secondary">Aucun commentaire</p>
        </div>
      </div>
      <div class="row">
        <div
          class="row mt-1 clickable container-comments"
          :style="'max-height:' + setheight + 'em'"
        >
          <template v-for="comment in commentList">
            <div class="row px-2 pt-2 fullwidth">
              <div class="flex md11">
                <div
                  class="row row-inside"
                  @click="updateComment(comment)"
                >
                  <div class="flex md2">
                    <p>{{ convertDate(comment.date_creation) }}</p>
                  </div>
                  <div class="flex md7 fullwidth">
                    <p>{{ comment.text }}</p>
                  </div>
                  <div class="flex md3 test">
                    <p>
                      {{ comment.createur.nom + " " + comment.createur.prenom }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="flex md1"
                @click="pinComment(comment)"
              >
                <va-icon
                  size="1em"
                  :color="comment.pinned ? 'info' : 'gray'"
                  name="glyphicon glyphicon-pushpin"
                  @hover
                />
              </div>

              <div class="flex md12 row-separator" />
            </div>
          </template>
        </div>
      </div>
    </div>
    <va-modal
      :title="editTitle"
      class="modal"
      large
      v-model="showEditor"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveRelance"
      v-on:cancel="closeModal"
    >
      <div class="row">
        <div class="flex md6">
          <p class="mb-2">
            Créé par
            {{
              activeComment.createur.prenom + " " + activeComment.createur.nom
            }}
          </p>
        </div>
        <div class="flex md6">
          <va-date-picker
            label="Date de création"
            v-model="activeComment.date_creation"
            :error="dateNotSet"
          />
        </div>

        <div class="flex md12">
          <va-input
            v-model="activeComment.text"
            label="Commentaire:"
            type="textarea"
            autosize
            :minRows="8"
            :maxRows="8"
            :error="textNotSet"
          />
        </div>
        <div class="flex md6">
          <va-button
            v-if="isAdmin"
            v-show="activeComment.idcomment"
            class="offset-delete fullwidth"
            color="danger"
            @click="showConfirmDelete = true"
          >Supprimer le commentaire</va-button>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer ce commentaire?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteComment()"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex } from "lodash";

export default {
  name: "commentManager",
  props: ["iddevis_publications", "setheight"],

  data() {
    return {
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      showConfirmDelete: false,
      textNotSet: false,
      editTitle: "Editer le commentaire",
      selectAssignee: "",
      showEditor: false,
      commentList: [],
      statutsColor: "info",
      activeComment: this.resetActiveComment(),
      dateNotSet: false,
    };
  },
  mounted() {
    this.loadComments(this.iddevis_publications);
  },
  methods: {
    async pinComment(comment) {
      try {
        console.log(comment);
        let params = { idcomment: comment.idcomment, pinned: !comment.pinned };
        let res = await axios.post("/api/publications-web/comment-pin", params);
        this.loadComments(this.iddevis_publications);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur le commentaire ne peut pas être épinglé"
        );
      }
    },
    createNew() {
      this.activeComment = this.resetActiveComment();
      this.editTitle = "Créer un commentaire";
      this.showEditor = true;
    },
    updateComment(comment) {
      this.activeComment = cloneDeep(comment);
      this.editTitle = "Editer le commentaire";
      this.showEditor = true;
    },
    async deleteComment() {
      if (this.activeComment.idcomment) {
        try {
          let commenttodelete = cloneDeep(this.activeComment);
          await axios.delete("/api/publications-web/delete-comment", {
            data: commenttodelete,
          });
          let index = findIndex(this.commentList, {
            idcomment: this.activeComment.idcomment,
          });
          this.commentList.splice(index, 1);
          this.activeComment = this.resetActiveComment();
          this.launchEpicmaxToast("Commentaire supprimé");
          this.showEditor = false;
        } catch (err) {
          console.log(err);
          this.launchEpicmaxToast(
            "Erreur lors de la suppression du commentaire"
          );
        }
      } else {
        this.launchEpicmaxToast("Le commentaire n'est pas sauvegardée");
      }
      this.textNotSet = false;
      this.dateNotSet = false;
    },
    convertDate(date) {
      let t = date.split("-");
      return t[2] + "-" + t[1] + "-" + t[0];
    },
    async loadComments(iddevis_publications) {
      try {
        let rlist = await axios.get("/api/publications-web/comments", {
          params: {
            id: iddevis_publications,
          },
        });

        this.commentList = rlist.data;
        this.textNotSet = false;
      } catch (error) {
        console.log(error);
      }
    },
    resetActiveComment() {
      let today = new Date();
      let month = today.getUTCMonth() + 1; //months from 1-12
      let day = today.getUTCDate();
      let year = today.getUTCFullYear();

      let newdate = year + "-" + month + "-" + day;
      return {
        idcomment: null,
        iddevis_publications: this.iddevis_publications,
        text: null,
        createur_idutilisateur: this.$store.getters.user.idutilisateurs,
        date_creation: newdate,
        createur: {
          nom: this.$store.getters.user.nom,
          prenom: this.$store.getters.user.prenom,
        },
      };
      this.textNotSet = false;
    },
    async saveRelance() {
      this.showEditor = true;
      // check that the mandatory fields are set
      if (!this.activeComment.text) {
        this.textNotSet = true;
        return;
      } else {
        this.textNotSet = false;
      }

      try {
        //update or create
        if (this.activeComment.idcomment) {
          let commentres = await axios.post(
            "/api/publications-web/update-comment",
            this.activeComment
          );
          this.loadComments(this.iddevis_publications);
          this.launchEpicmaxToast("Commentaire mis à jour");
          this.showEditor = false;
          this.activeComment = this.resetActiveComment();
        } else {
          let commentres = await axios.post(
            "/api/publications-web/create-comment",
            this.activeComment
          );
          this.loadComments(this.iddevis_publications);
          this.launchEpicmaxToast("Commentaire sauvegardé");
          this.showEditor = false;
          this.activeComment = this.resetActiveComment();
        }
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la sauvegarde du commentaire");
      }
    },
    closeModal() {
      this.activeComment = this.resetActiveComment();
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    iddevis_publications(newid) {
      if (newid) {
        this.loadComments(newid);
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.offset-delete {
  position: relative;
  top: -1em;
}

.container-comments {
  overflow: auto;
  overflow-x: hidden;
}
.clickable {
  display: flex;
  :hover {
    background-color: $light-gray3;
    cursor: pointer;
  }
}
.fullwidth {
  width: 95%;
}
.row-separator {
  width: 100%;
  border-color: #babfc2;
  border-width: 1px;
  border-bottom-style: solid;
}
</style>
